/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it safe to generate passwords online here?`)
};

const es_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es seguro generar contraseñas en línea aquí?`)
};

const de_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist es sicher, Passwörter hier online zu generieren?`)
};

const nl_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is het veilig om hier online wachtwoorden te genereren?`)
};

const fr_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-il sûr de générer des mots de passe en ligne ici?`)
};

const it_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È sicuro generare password online qui?`)
};

const pt_br2_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É seguro gerar senhas online aqui?`)
};

const pt_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É seguro gerar senhas online aqui?`)
};

const ja_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここでオンラインでパスワードを生成するのは安全ですか?`)
};

const zh_pw_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在这里在线生成密码安全吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq2_q", locale)
	if (locale === "en") return en_pw_faq2_q(inputs)
	if (locale === "es") return es_pw_faq2_q(inputs)
	if (locale === "de") return de_pw_faq2_q(inputs)
	if (locale === "nl") return nl_pw_faq2_q(inputs)
	if (locale === "fr") return fr_pw_faq2_q(inputs)
	if (locale === "it") return it_pw_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq2_q(inputs)
	if (locale === "pt") return pt_pw_faq2_q(inputs)
	if (locale === "ja") return ja_pw_faq2_q(inputs)
	return zh_pw_faq2_q(inputs)
};